export function H3(props) {
  return (
    <h4 className="pd-panel__header--h4" id={props.id}>
      {props.children}
    </h4>
  );
}

export default H3;
